<div style="padding:5px">
    <h3>Filter options</h3>
    <div class="chip-container">
        <mat-chip-listbox [(ngModel)]="preferences" selectable multiple (change)="onFilterClick($event)">
            @for (o of filterOptions; track o) {
                <mat-chip-option [value]="o">{{o}}</mat-chip-option>    
            }
        </mat-chip-listbox>
        <button mat-raised-button (click)="savePreferences()" color="accent">Save preferences</button>
    </div>
</div>

<div class="hint">Click on a bar in the graph below to view the nodes with that warning.</div>

<app-warnings-overview [warnings]="warnings" (selectBarEvent)="handleSelectWarning($event)"></app-warnings-overview>

@if (warningSelected) {
    <div class="hint">Currently viewing warnings for {{warningSelected}}. Clicking on a node (row) will focus on that node in the model. Double click the row or click the edit icon to edit the node properties.</div>
}

<div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header justify="center"></th>
            <td mat-cell *matCellDef="let row">
                <app-node-svg [type]="row.node.type"/>
            </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header justify="start">Name</th>
            <td mat-cell *matCellDef="let row">{{row.node.name}}</td>
        </ng-container>

        <ng-container matColumnDef="warning1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header justify="start">Warning 1</th>
            <td mat-cell *matCellDef="let row" color="accent">{{getWarningText(row.warnings[0])}}</td>
        </ng-container>

        <ng-container matColumnDef="warning2">
            <th mat-header-cell *matHeaderCellDef mat-sort-header justify="start">Warning 2</th>
            <td mat-cell *matCellDef="let row" color="accent">{{getWarningText(row.warnings[1])}}</td>
        </ng-container>

        <ng-container matColumnDef="warning3">
            <th mat-header-cell *matHeaderCellDef mat-sort-header justify="start">Warning 3</th>
            <td mat-cell *matCellDef="let row" color="accent">{{getWarningText(row.warnings[2])}}</td>
        </ng-container>

        <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button color="accent" matTooltip="Edit the node" (click)="editRow(element);$event.stopPropagation()">
                    <mat-icon class="mat-18">edit</mat-icon>
                </button>
            </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row [id]="row.node._key" (dblclick)="editRow(row)" (click)="selectRow(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
</div>